<template>
	<button
		:disabled="disabled"
		class="flex items-center js-add-to-cart-button"
        :class="{'adding': adding}"
	>
        <ShoppingCartIcon class="h-6 mr-2 font-normal icon"/>
    	<span class="text"><slot/></span>
  	</button>
</template>

<script>
    import { ShoppingCartIcon } from '@heroicons/vue/outline'
	export default {
        components: {
            ShoppingCartIcon
        },
  		props: {
    		adding: Boolean,
			disabled: Boolean
  		}
	}
</script>
